import { stringify } from "querystring";

export default class ExerciseEditController {
    constructor($location, $routeParams, $mdDialog, exerciseService, notificationsService, globalConstants) {
        this.$location = $location;
        this.exerciseService = exerciseService;
        this.$routeParams = $routeParams;
        this.$mdDialog = $mdDialog;
        this.notificationsService = notificationsService;
        this.documentData = {};
        this.globalConstants = globalConstants;
        
        exerciseService.get($routeParams.exerciseId).then(resp => {
            this.exercise = resp.data;
            this.exercise.time = new Date(this.exercise.time);
            this.exercise.clockBase = this.exercise.clockBase ? new Date(this.exercise.clockBase) : new Date(2018, 1, 1, 9, 0, 0, 0);
            this.exercise.eventId = $routeParams.eventId;
            this.exercise.id = $routeParams.exerciseId;
        }, error => {
            $location.path("/");
        });
    }
    onSave(file) {
        var that = this; 

            var exercise = {
                id: that.exercise.id,
                name: that.exercise.name,
                time: that.exercise.time,
                clockBase: that.exercise.clockBase,
                eventId: that.$routeParams.eventId,
                description: that.exercise.description,
                postcode: that.exercise.postcode,
                exerciseMessageCharacters: that.exercise.exerciseMessageCharacters,
                themeId: that.exercise.themeId,
                themeAccentColour: that.exercise.themeAccentColour,
                themeCustomName: that.exercise.themeCustomName,
                hidden: that.exercise.hidden,
            };

            if(this.documentData.doc && this.documentData.mimetype && this.documentData.fileextension)
            {
                if(that.exercise.doc != this.documentData.doc){
                    exercise.plan = this.documentData.doc;
                    exercise.doctype = this.documentData.mimetype;
                    exercise.planFileExtension = this.documentData.fileextension;
                }
            }

            that.exerciseService.updateExercise(exercise).then(resp => {
                    that.$location.path("/manage/clients/" + that.$routeParams.clientId + "/events/view/" + that.$routeParams.eventId);
                    that.notificationsService.show("Exercise updated", "success");
                }, 
                resp => { 
                    that.notificationsService.show("Form fields not complete", "error");
                });
    }

    goBack(){
        this.$location.path("/manage/clients/" +this.$routeParams.clientId+"/events/view/"+this.$routeParams.eventId);
    }

    readFile() {
        return new Promise(function (resolve, reject) {
            var f = document.getElementById('file').files[0],
                r = new FileReader(),
                data = [];

                if(!f){
                    resolve(data);
                }

            var mimetype = f.type;

            r.onloadend = function (e) {
                var doc = btoa(new Uint8Array(e.target.result).reduce(function (data, byte){
                    return data + String.fromCharCode(byte);
                }, ''));
                data.doc = doc;
                data.mimetype = mimetype;
                data.fileextension = f.name.split('.').pop();
                resolve(data);
            }
            r.readAsArrayBuffer(f);
        });
    };

    delete() {
        this.exerciseService.delete(this.$routeParams.eventId, this.$routeParams.exerciseId).then(resp => {
            this.$location.path("/manage/clients/" +this.$routeParams.clientId+"/events/view/"+this.$routeParams.eventId);
            this.notificationsService.show("Exercise deleted", "success");
        });
    }

    showWarning(ev) {
        this.$mdDialog.show({
            contentElement: '#deleteExerciseDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };

    hideWarning(ev) {
        this.$mdDialog.hide({
            contentElement: '#deleteExerciseDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };
}


// WEBPACK FOOTER //
// ./src/js/components/exercise/exercise.edit.controller.js